import { render, staticRenderFns } from "./mobileGame.vue?vue&type=template&id=7b193119&scoped=true&"
import script from "./mobileGame.vue?vue&type=script&lang=js&"
export * from "./mobileGame.vue?vue&type=script&lang=js&"
import style1 from "./mobileGame.vue?vue&type=style&index=1&id=7b193119&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b193119",
  null
  
)

export default component.exports